// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"59e852d13b567767","6831":"d482488dcf5b73ad","8503":"5ad2f3f3dd3e163d","9683":"de072748c77b06d9"}[chunkId] + ".js";
};